import type { RouteObject } from "react-router-dom";
import {
  Applications,
  DeviceActivity,
  Groups,
  LinkedAccounts,
  Oid4Vci,
  Organizations,
  PersonalInfo,
  Resources,
  SigningIn,
} from "@keycloak/keycloak-account-ui";
import App from "./App";
import { environment } from "./environment";
import { Hub } from "./Hub";

/* The Hub is the index route and renders full-bleed with no console chrome.
 * Every standard account page nests under the App layout (masthead + nav)
 * via a pathless layout route.
 *
 * IMPORTANT: paths mirror the stock keycloak-account-ui routes exactly
 * (kebab-case, e.g. account-security/signing-in) so deep links and any
 * internal navigation keep working. The one intentional difference: stock
 * PersonalInfo is the index route; here the Hub is the index and Personal
 * info lives at /personal-info. */

export const HubRoute: RouteObject = {
  index: true,
  element: <Hub />,
};

export const PersonalInfoRoute: RouteObject = {
  path: "personal-info",
  element: <PersonalInfo />,
};

export const DeviceActivityRoute: RouteObject = {
  path: "account-security/device-activity",
  element: <DeviceActivity />,
};

export const LinkedAccountsRoute: RouteObject = {
  path: "account-security/linked-accounts",
  element: <LinkedAccounts />,
};

export const SigningInRoute: RouteObject = {
  path: "account-security/signing-in",
  element: <SigningIn />,
};

export const ApplicationsRoute: RouteObject = {
  path: "applications",
  element: <Applications />,
};

export const GroupsRoute: RouteObject = {
  path: "groups",
  element: <Groups />,
};

export const OrganizationsRoute: RouteObject = {
  path: "organizations",
  element: <Organizations />,
};

export const ResourcesRoute: RouteObject = {
  path: "resources",
  element: <Resources />,
};

export const Oid4VciRoute: RouteObject = {
  path: "oid4vci",
  element: <Oid4Vci />,
};

export const ConsoleLayoutRoute: RouteObject = {
  element: <App />,
  children: [
    PersonalInfoRoute,
    DeviceActivityRoute,
    LinkedAccountsRoute,
    SigningInRoute,
    ApplicationsRoute,
    GroupsRoute,
    OrganizationsRoute,
    ResourcesRoute,
    Oid4VciRoute,
  ],
};

export const RootRoute: RouteObject = {
  path: decodeURIComponent(new URL(environment.baseUrl).pathname),
  errorElement: <>Error</>,
  children: [HubRoute, ConsoleLayoutRoute],
};

export const routes: RouteObject[] = [RootRoute];
